import { render, staticRenderFns } from "./PromotionAndDiscount.vue?vue&type=template&id=177fda7e&"
import script from "./PromotionAndDiscount.vue?vue&type=script&lang=js&"
export * from "./PromotionAndDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports